// Headers created by the shared request template are hidden in result panels
// so operators can focus on the request differences for the selected job.
const COMMON_REQUEST_HEADER_DEFAULTS = {
  Accept: "*/*",
  "Accept-Language": "zh-CN,zh;q=0.9",
  "Biz-ClientType": "1042",
  "Biz-DeviceBrand": "iPhone",
  "Biz-DistributionId": "1011",
  "Biz-Language": "1002",
  "Biz-MerchantId": "2000001",
  "Biz-ProductChannelId": "1011",
  "Biz-ProductId": "1",
  "Biz-Protocol": "1001",
  "Biz-ServerEnv": "20001",
  "Biz-SessionKey": "",
  "Biz-SessionType": "c",
  "Biz-UserId": "",
  "Cache-Control": "no-cache",
  Connection: "keep-alive",
  "Content-Type": "application/json",
  Pragma: "no-cache",
  "Sec-Fetch-Dest": "empty",
  "Sec-Fetch-Mode": "cors",
  "Sec-Fetch-Site": "same-origin",
  "sec-ch-ua": '"Google Chrome";v="149", "Chromium";v="149", "Not)A;Brand";v="24"',
  "sec-ch-ua-mobile": "?1",
  "sec-ch-ua-platform": '"iOS"',
};

export function displayResponse(value, fallback) {
  if (!value) {
    return fallback;
  }
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch (error) {
    return value;
  }
}

export function formatRequestParams(result) {
  if (!result || !result.http_request) {
    return "";
  }
  const request = result.http_request;
  return JSON.stringify(
    {
      method: request.method || "",
      url: request.url || "",
      headers: filteredRequestHeaders(request),
      params: request.params || {},
      body: request.body === undefined ? null : request.body,
    },
    null,
    2,
  );
}

export function formatResponseBody(result) {
  if (!result) {
    return "";
  }
  const body =
    result.http_response && result.http_response.body !== undefined
      ? result.http_response.body
      : result.response;
  return displayResponse(body, "");
}

export function assertionFailureReasons(assertion) {
  if (!assertion || assertion.skipped || assertion.ok) {
    return [];
  }
  if (assertion.error) {
    return [assertion.error];
  }

  const failedChecks = Array.isArray(assertion.checks)
    ? assertion.checks.filter((check) => !check.ok)
    : [];

  if (!failedChecks.length) {
    return [`规则 ${assertion.rule || "-"} 未通过`];
  }

  return failedChecks.map((check) => {
    const source = check.source === "database" ? "数据库断言" : "返回断言";
    if (check.error) {
      return `${source} ${check.rule || "-"}：${check.error}`;
    }
    return [
      `${source} ${check.rule || "-"}`,
      `实际 ${displayValue(check.actual)}`,
      `期望 ${check.operator || "="} ${displayValue(check.expected)}`,
    ].join("：");
  });
}

function filteredRequestHeaders(request) {
  const headers = request.headers || {};
  return Object.keys(headers).reduce((result, key) => {
    const value = headers[key];
    if (!isCommonRequestHeader(key, value, request.url)) {
      result[key] = value;
    }
    return result;
  }, {});
}

function isCommonRequestHeader(key, value, url) {
  const headerName = String(key || "");
  const normalizedName = headerName.toLowerCase();
  const normalizedValue = String(value ?? "");
  const defaultEntry = Object.entries(COMMON_REQUEST_HEADER_DEFAULTS).find(
    ([name]) => name.toLowerCase() === normalizedName,
  );

  if (defaultEntry && normalizedValue === String(defaultEntry[1])) {
    return true;
  }
  if (normalizedName === "origin" && normalizedValue === defaultOrigin(url)) {
    return true;
  }
  if (normalizedName === "referer" && normalizedValue === `${defaultOrigin(url)}/pages/login/login`) {
    return true;
  }
  return normalizedName === "host" || normalizedName === "content-length";
}

function defaultOrigin(url) {
  try {
    const parsed = new URL(url);
    return parsed.origin;
  } catch (error) {
    return "";
  }
}

function displayValue(value) {
  if (value === undefined) {
    return "undefined";
  }
  try {
    return JSON.stringify(value);
  } catch (error) {
    return String(value);
  }
}

